<template>
  <!-- Edit / Add Employee (PRIMARY FORM) -->
  <div class="modal fade" id="edit_employee">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="d-flex align-items-center">
            <h4 class="modal-title me-2">
              {{ isEdit ? "Edit Employee" : "Add New Employee" }}
            </h4>
            <span>Employee ID : {{ displayEmpId }}</span>
          </div>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form ref="employeeFormRef" @submit.prevent="submitMain" novalidate>
          <div class="contact-grids-tab">
            <ul class="nav nav-underline" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="info-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#basic-info"
                  type="button"
                  role="tab"
                  aria-selected="true"
                >
                  Basic Information
                </button>
              </li>
            </ul>
          </div>

          <div class="tab-content" id="myTabContent">
            <!-- TAB: BASIC INFO -->
            <div
              class="tab-pane fade show active"
              id="basic-info"
              role="tabpanel"
              aria-labelledby="info-tab"
              tabindex="0"
            >
              <div class="modal-body pb-0">
                <div class="row">
                  <!-- Avatar -->
                  <div class="col-md-12">
                    <div
                      class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4"
                    >
                      <div
                        class="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames"
                      >
                        <img
                          v-if="form.imageUrl"
                          :src="form.imageUrl"
                          class="rounded-circle"
                          style="width: 60px; height: 60px"
                        />
                        <i v-else class="ti ti-photo text-gray-2 fs-16"></i>
                      </div>
                      <div class="profile-upload">
                        <div class="mb-2">
                          <h6 class="mb-1">Upload Profile Image</h6>
                          <p class="fs-12">Image should be below 4 mb</p>
                        </div>
                        <div class="profile-uploader d-flex align-items-center">
                          <div
                            class="drag-upload-btn btn btn-sm btn-primary me-2"
                          >
                            Upload
                            <input
                              type="file"
                              accept="image/*"
                              class="form-control image-sign"
                              @change="onImageChange"
                              :disabled="!fieldAccess.avatar"
                            />
                          </div>
                          <a
                            v-if="form.imageUrl"
                            href="javascript:void(0);"
                            class="btn btn-light btn-sm"
                            @click="removeImage"
                            :class="{ disabled: !fieldAccess.avatar }"
                            :aria-disabled="!fieldAccess.avatar"
                            >Cancel</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Names -->
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >First Name <span class="text-danger">*</span></label
                      >
                      <input
                        v-model.trim="form.first_name"
                        type="text"
                        class="form-control"
                        required
                        :readonly="!fieldAccess.first_name"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Last Name</label>
                      <input
                        v-model.trim="form.last_name"
                        type="text"
                        class="form-control"
                        :readonly="!fieldAccess.last_name"
                      />
                    </div>
                  </div>

                  <!-- Employee ID & DOJ -->
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Employee ID <span class="text-danger">*</span></label
                      >
                      <input
                        v-model="form.employee_id"
                        type="text"
                        class="form-control"
                        :readonly="isEdit || !fieldAccess.employee_id"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Joining Date <span class="text-danger">*</span></label
                      >
                      <div class="input-icon-end position-relative">
                        <date-picker
                          v-model="form.company_doj"
                          class="form-control datetimepicker"
                          placeholder="dd/mm/yyyy"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                          :disabled="!fieldAccess.company_doj"
                        />
                        <span class="input-icon-addon">
                          <i class="ti ti-calendar text-gray-7"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Username / Email -->
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Username <span class="text-danger">*</span></label
                      >
                      <input
                        v-model.trim="form.username"
                        type="text"
                        class="form-control"
                        required
                        :readonly="!fieldAccess.username"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Email <span class="text-danger">*</span></label
                      >
                      <input
                        v-model.trim="form.email"
                        type="email"
                        class="form-control"
                        required
                        :readonly="!fieldAccess.email"
                      />
                    </div>
                  </div>

                  <div v-if="isEdit && fieldAccess.status" class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Employment status</label>
                      <select
                        v-model="form.status"
                        class="form-select"
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>
                  </div>

                  <div
                    v-if="isEdit && hasLinkedUser && canManageEmployees"
                    class="col-12"
                  >
                    <div class="alert alert-light border d-flex align-items-start justify-content-between gap-3">
                      <div>
                        <div class="fw-semibold mb-1">
                          Portal login is already linked
                        </div>
                        <div class="text-muted small" v-if="usesPlaceholderEmail">
                          Replace the imported placeholder email first before
                          resending a set-password link.
                        </div>
                        <div class="text-muted small" v-else>
                          This employee is linked to a user account. Resend the
                          set-password email if they never received it.
                        </div>
                      </div>

                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        :disabled="resendingSetPassword || usesPlaceholderEmail"
                        @click="resendSetPasswordEmail"
                      >
                        <span
                          v-if="resendingSetPassword"
                          class="spinner-border spinner-border-sm me-1"
                        ></span>
                        Resend email
                      </button>
                    </div>
                  </div>

                  <div
                    v-if="isEdit && !hasLinkedUser && canManageEmployees"
                    class="col-12"
                  >
                    <div class="alert alert-light border d-flex align-items-start justify-content-between gap-3">
                      <div>
                        <div class="fw-semibold mb-1">
                          Create login access for this employee
                        </div>
                        <div class="text-muted small" v-if="usesPlaceholderEmail">
                          Replace the imported placeholder email first. Login
                          access cannot be created with a placeholder email.
                        </div>
                        <div class="text-muted small" v-else>
                          When enabled, the system creates a linked employee
                          user, marks the email as already verified, and can
                          send login details immediately.
                        </div>
                      </div>

                      <label class="form-check form-switch mb-0 pt-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="form.create_login_user"
                          :disabled="usesPlaceholderEmail"
                        />
                      </label>
                    </div>
                  </div>

                  <div
                    v-if="isEdit && !hasLinkedUser && form.create_login_user"
                    class="col-12"
                  >
                    <div class="alert alert-light border d-flex align-items-start justify-content-between gap-3">
                      <div>
                        <div class="fw-semibold mb-1">
                          Send login details by email
                        </div>
                        <div class="text-muted small">
                          Recommended when provisioning first-time access for an
                          imported employee.
                        </div>
                      </div>

                      <label class="form-check form-switch mb-0 pt-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="form.send_welcome_email"
                        />
                      </label>
                    </div>
                  </div>

                  <!-- KRA / National ID -->
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Tax Payer Pin <span class="text-danger">*</span></label
                      >
                      <input
                        v-model.trim="form.kra_pin"
                        type="text"
                        class="form-control"
                        required
                        :readonly="!fieldAccess.kra_pin"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >National ID <span class="text-danger">*</span></label
                      >
                      <input
                        v-model.trim="form.national_id"
                        type="text"
                        class="form-control"
                        required
                        :readonly="!fieldAccess.national_id"
                      />
                    </div>
                  </div>

                  <!-- Phone -->
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >Phone Number <span class="text-danger">*</span></label
                      >
                      <input
                        v-model.trim="form.phone"
                        type="text"
                        class="form-control"
                        required
                        :readonly="!fieldAccess.phone"
                      />
                    </div>
                  </div>

                  <!-- Company (readonly – server-side tenant) -->
                  <div class="col-md-6 display-none">
                    <div class="mb-3">
                      <label class="form-label"
                        >Company<span class="text-danger"> *</span></label
                      >
                      <vue-select
                        v-if="isSuperAdmin && fieldAccess.company_id"
                        v-model="form.company_id"
                        :options="companies"
                        label="text"
                        placeholder="Select Company"
                        :clearable="false"
                      />
                      <input
                        v-else
                        type="text"
                        class="form-control"
                        :value="companyLabel"
                        disabled
                      />
                    </div>
                  </div>

                  <!-- Department / Section / Designation -->
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Department</label>
                      <vue-select
                        v-model="form.department_id"
                        :options="departments"
                        label="name"
                        track-by="id"
                        placeholder="Select Department"
                        :reduce="(d) => d?.id"
                        :disabled="!fieldAccess.department_id"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Section</label>
                      <vue-select
                        v-model="form.section_id"
                        :options="filteredSections"
                        label="name"
                        track-by="id"
                        :disabled="
                          !form.department_id || !fieldAccess.section_id
                        "
                        :placeholder="
                          form.department_id
                            ? 'Select Section (optional)'
                            : 'Select Department first'
                        "
                        :reduce="(d) => d?.id"
                        :clearable="true"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Designation</label>
                      <vue-select
                        v-model="form.designation_id"
                        :options="filteredDesignations"
                        label="name"
                        track-by="id"
                        :disabled="
                          !form.department_id || !fieldAccess.designation_id
                        "
                        :placeholder="
                          form.department_id
                            ? 'Select Designation'
                            : 'Select Department first'
                        "
                        :reduce="(d) => d?.id"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Reports to (Manager)</label>
                      <div class="dropdown w-100 dq-emp-dd">
                        <button
                          id="manager-dd-btn"
                          class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                          type="button"
                          data-bs-toggle="dropdown"
                          :disabled="!fieldAccess.manager_id"
                          @click="onManagerDropdownOpen"
                        >
                          <span class="text-truncate">
                            {{ selectedManagerLabel }}
                          </span>
                          <i class="ti ti-chevron-down ms-2"></i>
                        </button>

                        <div
                          class="dropdown-menu p-2 w-100 shadow dq-dd-menu"
                          @click.stop
                        >
                          <input
                            ref="managerSearchRef"
                            v-model="managerQuery"
                            type="text"
                            class="form-control mb-2"
                            placeholder="Search employee name or ID..."
                            autocomplete="off"
                          />

                          <div class="dq-search-list">
                            <button
                              v-for="opt in filteredManagerOptions"
                              :key="opt.id"
                              type="button"
                              class="dropdown-item text-truncate dq-dd-item"
                              @click="chooseManager(opt)"
                            >
                              <div class="fw-semibold text-truncate">
                                {{ opt.text }}
                              </div>
                            </button>

                            <div
                              v-if="filteredManagerOptions.length === 0"
                              class="text-center py-2 small text-muted"
                            >
                              No active employee found
                            </div>
                          </div>

                          <div
                            class="d-flex justify-content-between align-items-center pt-2 border-top mt-2"
                          >
                            <button
                              type="button"
                              class="btn btn-sm btn-light"
                              @click="clearManager"
                            >
                              Clear
                            </button>

                            <span class="small text-muted">
                              {{ filteredManagerOptions.length }} result(s)
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label">Address</label>
                      <input
                        v-model.trim="form.address"
                        type="text"
                        class="form-control"
                        :readonly="!fieldAccess.address"
                      />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label"
                        >Date of Birth <span class="text-danger">*</span></label
                      >
                      <div class="input-icon-end position-relative">
                        <date-picker
                          v-model="form.dob"
                          class="form-control datetimepicker"
                          placeholder="dd/mm/yyyy"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                          :disabled="!fieldAccess.dob"
                        />
                        <span class="input-icon-addon">
                          <i class="ti ti-calendar text-gray-7"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Gender -->
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label"
                        >Gender <span class="text-danger">*</span></label
                      >
                      <vue-select
                        v-model="form.gender"
                        :options="['Male', 'Female', 'Other']"
                        placeholder="Select Gender"
                        :disabled="!fieldAccess.gender"
                      />
                    </div>
                  </div>

                  <!-- About -->
                  <div class="col-md-9">
                    <div class="mb-3">
                      <label class="form-label">About</label>
                      <textarea
                        ref="aboutTextareaRef"
                        id="employee-about-field"
                        v-model.trim="form.about"
                        class="form-control"
                        rows="3"
                        :readonly="!fieldAccess.about"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="submitting"
                >
                  <span
                    v-if="submitting"
                    class="spinner-border spinner-border-sm me-1"
                  ></span>
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
        <!-- /form -->
      </div>
    </div>
  </div>
  <!-- /Edit Employee -->

  <!-- The rest of your smaller modals (kept, submit hooks share submitMinor) -->
  <!-- Edit Personal -->
  <div class="modal fade" id="edit_personal">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Edit Personal Info</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="submitMinor">
          <div class="modal-body pb-0">
            <!-- keep your form UI as-is; bind if/when you add fields -->
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"
                    >Salary Basis <span class="text-danger"></span
                  ></label>
                  <vue-select
                    v-model="minorForm.salary_basis"
                    :options="['Monthly', 'Hourly', 'Weekly', 'Daily']"
                    id="salarybasis"
                    placeholder="Select"
                    :disabled="!fieldAccess.salary_basis"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"
                    >Payment Mode <span class="text-danger"></span
                  ></label>
                  <vue-select
                    v-model="minorForm.payment_mode"
                    :options="[
                      'Bank Transfer',
                      'Cash',
                      'Cheque',
                      'Mobile Money',
                    ]"
                    id="paymentmode"
                    placeholder="Select"
                    :disabled="!fieldAccess.payment_mode"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"
                    >Pay Frequency <span class="text-danger"></span
                  ></label>
                  <vue-select
                    v-model="minorForm.pay_frequency"
                    :options="['monthly', 'weekly', 'fortnightly', 'daily']"
                    id="payfrequency"
                    placeholder="Select"
                    :disabled="!fieldAccess.pay_frequency"
                  />
                  <div
                    v-if="nonMonthlyPayFrequencySelected"
                    class="form-text text-muted"
                  >
                    Use <strong>Monthly</strong> salary basis unless the employee is
                    paid by hour, day, or week. Statutory amounts are derived from a
                    monthly equivalent and scaled to each pay period.
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"
                    >Passport No <span class="text-danger"></span
                  ></label>
                  <input
                    v-model="minorForm.passport_no"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"
                    >Passport Expiry Date <span class="text-danger"></span
                  ></label>
                  <div class="input-icon-end position-relative">
                    <date-picker
                      v-model="minorForm.passport_expiry"
                      class="form-control datetimepicker"
                      placeholder="dd/mm/yyyy"
                      :editable="true"
                      :clearable="false"
                      :input-format="dateFormat"
                    />
                    <span class="input-icon-addon"
                      ><i class="ti ti-calendar text-gray-7"></i
                    ></span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"
                    >NSSF <span class="text-danger"></span
                  ></label>
                  <input
                    v-model="minorForm.nssf_number"
                    type="text"
                    class="form-control"
                    :readonly="!fieldAccess.nssf_number"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">SHA</label>
                  <input
                    v-model="minorForm.nhif_number"
                    type="text"
                    class="form-control"
                    :readonly="!fieldAccess.nhif_number"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"
                    >Nationality <span class="text-danger"></span
                  ></label>
                  <input
                    v-model="minorForm.nationality"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Religion</label>
                  <input
                    v-model="minorForm.religion"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label"
                    >Marital status <span class="text-danger"></span
                  ></label>
                  <vue-select
                    v-model="minorForm.marital_status"
                    :options="MartSel"
                    id="martsel"
                    placeholder="Select"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-white border me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="submitting"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Edit Emergency Contact -->
  <div class="modal fade" id="edit_emergency">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Emergency Contact Details</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="submitMinor">
          <div
            class="modal-body pb-0"
            :class="{ 'pe-none opacity-75': !fieldAccess.emergency }"
          >
            <div class="border-bottom mb-3">
              <div class="row">
                <h5 class="mb-3">Primary Contact Details</h5>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label"
                      >Name <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="minorForm.primary_emergency_contact_name"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Relationship</label>
                    <input
                      v-model="minorForm.primary_emergency_contact_relationship"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label"
                      >Phone No 1 <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="minorForm.primary_emergency_contact_phone"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Phone No 2</label>
                    <input
                      v-model="minorForm.primary_emergency_contact_phone_two"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <h5 class="mb-3">Secondary Contact Details</h5>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"
                    >Name <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="minorForm.secondary_emergency_contact_name"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Relationship</label>
                  <input
                    v-model="minorForm.secondary_emergency_contact_relationship"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label"
                    >Phone No 1 <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="minorForm.secondary_emergency_contact_phone"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Phone No 2</label>
                  <input
                    v-model="minorForm.secondary_emergency_contact_phone_two"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-white border me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="submitting"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Edit Bank -->
  <!-- Edit Bank -->
  <div class="modal fade" id="edit_bank">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Bank Details</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="submitMinor">
          <div class="modal-body pb-0">
            <div class="row">
              <!-- Bank Name (dropdown) -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">
                    Bank Name <span class="text-danger">*</span>
                  </label>

                  <div class="dropdown w-100">
                    <button
                      class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                      type="button"
                      data-bs-toggle="dropdown"
                    >
                      <span class="text-truncate">
                        {{ minorForm.bank_name || "Select bank" }}
                      </span>
                      <i class="ti ti-chevron-down ms-2"></i>
                    </button>

                    <div class="dropdown-menu p-2 w-100 shadow">
                      <input
                        v-model="bankQuery"
                        type="text"
                        class="form-control mb-2"
                        placeholder="Search bank..."
                        autocomplete="off"
                      />
                      <div
                        class="search-list"
                        style="max-height: 240px; overflow-y: auto"
                      >
                        <button
                          v-for="b in filteredBanks"
                          :key="b.bank_name"
                          type="button"
                          class="dropdown-item text-truncate"
                          @click="chooseBank(b)"
                        >
                          {{ b.bank_name }}
                        </button>
                        <div
                          v-if="filteredBanks.length === 0"
                          class="text-center py-2 small text-muted"
                        >
                          No bank found
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Bank Code (auto-filled, readonly) -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">
                    Bank Code <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="minorForm.bank_code"
                    type="text"
                    class="form-control"
                    readonly
                  />
                </div>
              </div>

              <!-- Account No -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">
                    Bank Account No <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="minorForm.account_number"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>

              <!-- Account Holder -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">
                    Bank Account Holder Name <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="minorForm.account_holder_name"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>

              <!-- Branch (dropdown) -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">
                    Bank Branch <span class="text-danger">*</span>
                  </label>

                  <div class="dropdown w-100">
                    <button
                      class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                      type="button"
                      :disabled="!minorForm.bank_name"
                      data-bs-toggle="dropdown"
                    >
                      <span class="text-truncate">
                        {{
                          minorForm.branch_location ||
                          (minorForm.bank_name
                            ? "Select branch"
                            : "Select bank first")
                        }}
                      </span>
                      <i class="ti ti-chevron-down ms-2"></i>
                    </button>

                    <div
                      v-if="minorForm.bank_name"
                      class="dropdown-menu p-2 w-100 shadow"
                    >
                      <input
                        v-model="branchQuery"
                        type="text"
                        class="form-control mb-2"
                        placeholder="Search branch..."
                        autocomplete="off"
                      />
                      <div
                        class="search-list"
                        style="max-height: 240px; overflow-y: auto"
                      >
                        <button
                          v-for="b in filteredBranches"
                          :key="b.bank_name + '-' + b.branch_code"
                          type="button"
                          class="dropdown-item text-truncate"
                          @click="chooseBranch(b)"
                        >
                          {{ b.branch_name }} ({{ b.branch_code }})
                        </button>
                        <div
                          v-if="filteredBranches.length === 0"
                          class="text-center py-2 small text-muted"
                        >
                          No branch found
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Branch Code (auto-filled, readonly) -->
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">
                    Branch Code <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="minorForm.branch_code"
                    type="text"
                    class="form-control"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-white border me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="submitting"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Edit Bank -->

  <!-- Family -->
  <div class="modal fade" id="edit_familyinformation">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Next of Kin Information</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="submitMinor">
          <div class="modal-body pb-0">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label"
                    >Name <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="minorForm.family_contact_name"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Relationship </label>
                  <input
                    v-model="minorForm.family_contact_relationship"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Phone </label>
                  <input
                    v-model="minorForm.family_contact_phone"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">No. of children</label>
                  <input
                    v-model="minorForm.no_of_children"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-white border me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="submitting"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Education -->
  <div class="modal fade" id="edit_education" width="1200">
    <div
      class="modal-dialog modal-dialog-centered modal-md"
      style="max-width: 600px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Education Information</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="submitMinor">
          <div class="modal-body pb-0">
            <div class="row">
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <h6 class="mb-0">Education Entries</h6>
                <button
                  type="button"
                  class="btn btn-sm btn-light"
                  @click="
                    minorForm.educations.push({
                      institution_name: '',
                      course: '',
                      start_date: null,
                      end_date: null,
                      graduated: false,
                    })
                  "
                >
                  <i class="ti ti-plus"></i> Add Education
                </button>
              </div>

              <div
                v-if="!minorForm.educations.length"
                class="alert alert-light"
              >
                No entries yet. Click <b>Add Education</b> to create one.
              </div>

              <div
                v-for="(edu, idx) in minorForm.educations"
                :key="'edu-' + idx"
                class="border rounded p-2 mb-3"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <strong>Entry #{{ idx + 1 }}</strong>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    @click="minorForm.educations.splice(idx, 1)"
                  >
                    <i class="ti ti-trash"></i>
                  </button>
                </div>
                <div class="row mt-2">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Institution Name</label>
                      <input
                        v-model="edu.institution_name"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Course</label>
                      <input
                        v-model="edu.course"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Start Date</label>
                      <div class="input-icon-end position-relative">
                        <date-picker
                          v-model="edu.start_date"
                          class="form-control datetimepicker"
                          :editable="true"
                          :clearable="true"
                          :input-format="dateFormat"
                        />
                        <span class="input-icon-addon"
                          ><i class="ti ti-calendar text-gray-7"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">End Date</label>
                      <div class="input-icon-end position-relative">
                        <date-picker
                          v-model="edu.end_date"
                          class="form-control datetimepicker"
                          :editable="true"
                          :clearable="true"
                          :input-format="dateFormat"
                        />
                        <span class="input-icon-addon"
                          ><i class="ti ti-calendar text-gray-7"></i
                        ></span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <label class="form-check-label d-flex align-items-center">
                      <input
                        class="form-check-input mt-0 me-2"
                        type="checkbox"
                        v-model="edu.graduated"
                      />
                      <span class="text-dark">Graduated</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-white border me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="submitting"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Experience -->
  <div class="modal fade" id="edit_experience">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Company Information</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="submitMinor">
          <div class="modal-body pb-0">
            <div class="row">
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <h6 class="mb-0">Experience Entries</h6>
                <button
                  type="button"
                  class="btn btn-sm btn-light"
                  @click="
                    minorForm.experiences.push({
                      company: '',
                      designation: '',
                      start_date: null,
                      end_date: null,
                      currently_working: false,
                      responsibilities: '',
                      supervisor_name: '',
                      supervisor_phone: '',
                    })
                  "
                >
                  <i class="ti ti-plus"></i> Add Experience
                </button>
              </div>

              <div
                v-if="!minorForm.experiences.length"
                class="alert alert-light"
              >
                No entries yet. Click <b>Add Experience</b> to create one.
              </div>

              <div
                v-for="(exp, idx) in minorForm.experiences"
                :key="'exp-' + idx"
                class="border rounded p-2 mb-3"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <strong>Entry #{{ idx + 1 }}</strong>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    @click="minorForm.experiences.splice(idx, 1)"
                  >
                    <i class="ti ti-trash"></i>
                  </button>
                </div>

                <div class="row mt-2">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Company</label>
                      <input
                        v-model="exp.company"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Designation</label>
                      <input
                        v-model="exp.designation"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Start Date</label>
                      <div class="input-icon-end position-relative">
                        <date-picker
                          v-model="exp.start_date"
                          class="form-control datetimepicker"
                          :editable="true"
                          :clearable="true"
                          :input-format="dateFormat"
                        />
                        <span class="input-icon-addon"
                          ><i class="ti ti-calendar text-gray-7"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">End Date</label>
                      <div class="input-icon-end position-relative">
                        <date-picker
                          v-model="exp.end_date"
                          class="form-control datetimepicker"
                          :editable="true"
                          :clearable="true"
                          :input-format="dateFormat"
                        />
                        <span class="input-icon-addon"
                          ><i class="ti ti-calendar text-gray-7"></i
                        ></span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="mb-3">
                      <label class="form-label">Responsibilities</label>
                      <textarea
                        v-model="exp.responsibilities"
                        class="form-control"
                        rows="2"
                      ></textarea>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Supervisor Name</label>
                      <input
                        v-model="exp.supervisor_name"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Supervisor Phone</label>
                      <input
                        v-model="exp.supervisor_phone"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-md-12">
                    <label
                      class="form-check-label d-flex align-items-center mt-0"
                    >
                      <input
                        class="form-check-input mt-0 me-2"
                        type="checkbox"
                        v-model="exp.currently_working"
                      />
                      <span class="text-dark">Currently working here</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-white border me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="submitting"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Success (optional – shown by your flows if needed) -->
  <div class="modal fade" id="success_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center p-3">
            <span class="avatar avatar-lg avatar-rounded bg-success mb-3"
              ><i class="ti ti-check fs-24"></i
            ></span>
            <h5 class="mb-2">Employee Saved Successfully</h5>
            <p class="mb-3">
              <span class="text-primary">#{{ displayEmpId }}</span>
            </p>
            <div class="row g-2">
              <div class="col-6">
                <router-link
                  to="/employee/employee-list"
                  class="btn btn-dark w-100"
                  >Back to List</router-link
                >
              </div>
              <div class="col-6">
                <router-link
                  v-if="createdId || employee?.id"
                  :to="{
                    path: '/employee/employee-details',
                    query: { id: createdId || employee?.id },
                  }"
                  class="btn btn-primary w-100"
                >
                  Detail Page
                </router-link>
                <button v-else class="btn btn-primary w-100" disabled>
                  Detail Page
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Asset Information + Refuse (kept static look) -->
  <div class="modal fade" id="asset_info">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Asset Information</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="bg-light p-3 rounded d-flex align-items-center mb-3">
            <span class="avatar avatar-lg flex-shrink-0 me-2">
              <span
                class="avatar avatar-lg rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center"
              >
                {{
                  (props.selectedAsset?.name || "A").slice(0, 1).toUpperCase()
                }}
              </span>
            </span>

            <div class="w-100">
              <h6 class="mb-1">
                {{ props.selectedAsset?.name || "—" }}
                <span class="badge bg-secondary-transparent ms-2">
                  {{ props.selectedAsset?.status || "—" }}
                </span>
              </h6>

              <p class="fs-13 mb-0">
                <span class="text-primary">
                  {{ props.selectedAsset?.asset_tag || "—" }}
                </span>
                <i class="ti ti-point-filled text-primary"></i>
                Purchased on
                {{
                  props.selectedAsset?.purchase_date
                    ? new Date(
                        props.selectedAsset.purchase_date
                      ).toLocaleDateString()
                    : "—"
                }}
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <p class="fs-13 mb-0">Category</p>
                <p class="text-gray-9">
                  {{ props.selectedAsset?.category?.name || "—" }}
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <p class="fs-13 mb-0">Serial No</p>
                <p class="text-gray-9">
                  {{ props.selectedAsset?.serial_number || "—" }}
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <p class="fs-13 mb-0">Manufacturer</p>
                <p class="text-gray-9">
                  {{ props.selectedAsset?.manufacturer || "—" }}
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <p class="fs-13 mb-0">Model</p>
                <p class="text-gray-9">
                  {{ props.selectedAsset?.model || "—" }}
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <p class="fs-13 mb-0">Cost</p>
                <p class="text-gray-9">
                  {{ props.selectedAsset?.purchase_cost ?? "—" }}
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <p class="fs-13 mb-0">Vendor</p>
                <p class="text-gray-9">
                  {{ props.selectedAsset?.supplier || "—" }}
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <p class="fs-13 mb-0">Warranty End</p>
                <p class="text-gray-9">
                  {{
                    props.selectedAsset?.warranty_end_date
                      ? new Date(
                          props.selectedAsset.warranty_end_date
                        ).toLocaleDateString()
                      : "—"
                  }}
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <p class="fs-13 mb-0">Location</p>
                <p class="text-gray-9">
                  {{ props.selectedAsset?.location || "—" }}
                </p>
              </div>
            </div>

            <div class="col-md-12">
              <div class="mb-0">
                <p class="fs-13 mb-0">Notes</p>
                <p class="text-gray-9 mb-0">
                  {{ props.selectedAsset?.notes || "—" }}
                </p>
              </div>
            </div>
          </div>

          <!-- <div>
            <p class="fs-13 mb-2">Asset Images</p>
            <div class="d-flex align-items-center">
              <img
                src="@/assets/img/laptop-01.jpg"
                alt="img"
                class="img-fluid rounded me-2"
              />
              <img
                src="@/assets/img/laptop-2.jpg"
                alt="img"
                class="img-fluid rounded me-2"
              />
              <img
                src="@/assets/img/laptop-3.jpg"
                alt="img"
                class="img-fluid rounded"
              />
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="refuse_msg">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Raise Issue</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="() => {}">
          <div class="modal-body pb-0">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label"
                    >Description<span class="text-danger"> *</span></label
                  >
                  <textarea class="form-control" rows="4"></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-white border me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal (kept, you likely already handle in list/grid) -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3"
            ><i class="ti ti-trash-x fs-36"></i
          ></span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete this employee, this can't be undone once you
            delete.
          </p>
          <div class="d-flex justify-content-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <a
              href="javascript:void(0);"
              @click.prevent="confirmDelete"
              class="btn btn-danger"
              >Yes, Delete</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/stores/authStore";
import { useEmployeeStore } from "@/stores/employeeStore";
import { useDepartmentStore } from "@/stores/departmentStore";
import { useDesignationStore } from "@/stores/designationStore";
import { useSectionStore } from "@/stores/sectionStore";
import { useCompanyStore } from "@/stores/companyStore";
import { banks as bankList } from "@/utils/banksData";
import employeeService from "@/services/hrm/employeeService";
import { toast } from "@/utils/toast";

const props = defineProps({
  employee: { type: Object, default: null },
  nextEmployeeId: { type: String, default: "EMP-0001" },
  selectedAsset: { type: Object, default: null },
});
const emit = defineEmits(["saved"]);

const EDITABLE_MODAL_IDS = [
  "edit_employee",
  "edit_personal",
  "edit_emergency",
  "edit_bank",
  "edit_familyinformation",
  "edit_education",
  "edit_experience",
  "delete_modal",
];

const aboutTextareaRef = ref(null);
const pendingFocusAbout = ref(false);
let editEmployeeModalEl = null;

function prepareOpen(opts = {}) {
  pendingFocusAbout.value = !!opts.focusAbout;
}

async function closeModal(id) {
  const el = document.getElementById(id);
  if (!el) return;

  try {
    if (window.bootstrap?.Modal) {
      const instance =
        window.bootstrap.Modal.getInstance(el) ||
        window.bootstrap.Modal.getOrCreateInstance(el);
      instance.hide();
    }
  } catch {
    // fall through to DOM cleanup
  }

  el.classList.remove("show");
  el.style.display = "none";
  el.setAttribute("aria-hidden", "true");
  el.removeAttribute("aria-modal");
  el.removeAttribute("role");

  // Only clear body lock if no other Bootstrap modal is still open.
  const anotherOpen = EDITABLE_MODAL_IDS.some((mid) => {
    if (mid === id) return false;
    const m = document.getElementById(mid);
    return !!m && m.classList.contains("show");
  });

  if (!anotherOpen) {
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
    document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
  }
}

async function closeOpenEditableModals(preferredId = null) {
  if (preferredId) {
    await closeModal(preferredId);
    return;
  }

  for (const id of EDITABLE_MODAL_IDS) {
    const el = document.getElementById(id);
    if (el?.classList.contains("show") || el?.style.display === "block") {
      await closeModal(id);
    }
  }
}

async function focusAboutField() {
  await nextTick();

  // Prefer ref, fall back to id (more reliable inside Bootstrap modal).
  const ta =
    aboutTextareaRef.value ||
    document.getElementById("employee-about-field");
  if (!ta) return;

  const getScrollParent = (node) => {
    let el = node?.parentElement;
    while (el) {
      const style = window.getComputedStyle(el);
      const canScroll =
        /(auto|scroll|overlay)/.test(style.overflowY) &&
        el.scrollHeight > el.clientHeight + 8;
      if (canScroll) return el;
      if (el.classList?.contains("modal-body") || el.classList?.contains("modal-dialog")) {
        // Prefer modal containers even if overflow isn't computed yet.
        if (el.scrollHeight > el.clientHeight + 8) return el;
      }
      if (el.id === "edit_employee") break;
      el = el.parentElement;
    }
    return (
      document.querySelector("#edit_employee .modal-body") ||
      document.querySelector("#edit_employee .modal-dialog") ||
      null
    );
  };

  const scrollToAbout = () => {
    const scrollParent = getScrollParent(ta);
    if (scrollParent) {
      const parentRect = scrollParent.getBoundingClientRect();
      const taRect = ta.getBoundingClientRect();
      const offset =
        taRect.top - parentRect.top + scrollParent.scrollTop - 32;
      scrollParent.scrollTo({
        top: Math.max(0, offset),
        behavior: "smooth",
      });
    } else {
      try {
        ta.scrollIntoView({ behavior: "smooth", block: "center" });
      } catch {
        // ignore
      }
    }
  };

  // Modal animation can still be settling — retry a couple times.
  scrollToAbout();
  window.setTimeout(scrollToAbout, 150);
  window.setTimeout(scrollToAbout, 350);

  if (ta.readOnly) return;

  window.setTimeout(() => {
    ta.focus({ preventScroll: true });
    const len = ta.value?.length || 0;
    try {
      ta.setSelectionRange(len, len);
    } catch {
      // ignore
    }
  }, 200);
}

async function onEditEmployeeShown() {
  if (!pendingFocusAbout.value) return;
  // Keep flag until after retries, then clear.
  const shouldFocus = pendingFocusAbout.value;
  pendingFocusAbout.value = false;
  if (!shouldFocus) return;
  await focusAboutField();
}

async function openEditEmployeeModal(opts = {}) {
  prepareOpen(opts);
  await nextTick();
  const el = document.getElementById("edit_employee");
  if (!el) return;
  if (window.bootstrap?.Modal) {
    window.bootstrap.Modal.getOrCreateInstance(el).show();
  } else {
    el.classList.add("show");
    el.style.display = "block";
  }
  // Fallback if shown.bs.modal already fired / is missed.
  if (opts.focusAbout) {
    window.setTimeout(() => {
      if (document.getElementById("edit_employee")?.classList.contains("show")) {
        focusAboutField();
      }
    }, 350);
  }
}

const employeeStore = useEmployeeStore();
const departmentStore = useDepartmentStore();
const designationStore = useDesignationStore();
const sectionStore = useSectionStore();
const companyStore = useCompanyStore();

// const { departments } = storeToRefs(departmentStore);
// const { designations } = storeToRefs(designationStore);

const authStore = useAuthStore();
const { user: authUser } = storeToRefs(authStore);

const { activeCompanyId } = storeToRefs(companyStore);

// Departments & Designations
const departments = computed(() =>
  departmentStore.departments.map((d) => ({ id: d.id, name: d.name, text: d.name }))
);
const designations = computed(() =>
  designationStore.designations.map((d) => ({ id: d.id, name: d.name, text: d.name }))
);

const allSections = computed(() =>
  sectionStore.sections.map((s) => ({
    id: s.id,
    name: s.name,
    text: s.name,
    department_id: s.department_id,
  }))
);

const allDesignations = computed(() =>
  designationStore.designations.map((d) => ({
    id: d.id,
    name: d.name,
    text: d.name,
    department_id: d.department_id,
    section_id: d.section_id,
  }))
);

const filteredSections = computed(() => {
  const depId =
    form.department_id == null || form.department_id === ""
      ? null
      : Number(form.department_id);
  if (!depId) return [];
  return allSections.value.filter((s) => Number(s.department_id) === depId);
});

const filteredDesignations = computed(() => {
  const depId =
    form.department_id == null || form.department_id === ""
      ? null
      : Number(form.department_id);
  if (!depId) return [];
  const secId =
    form.section_id == null || form.section_id === ""
      ? null
      : Number(form.section_id);
  return allDesignations.value.filter((d) => {
    if (Number(d.department_id) !== depId) return false;
    if (!secId) return true;
    return !d.section_id || Number(d.section_id) === secId;
  });
});

const managerQuery = ref("");
const managerSearchRef = ref(null);

function formatEmployeeOptionLabel(e) {
  const name = [e?.first_name, e?.last_name].filter(Boolean).join(" ").trim();
  const code = e?.employee_id ? ` (${e.employee_id})` : "";
  return `${name || "Employee"}${code}`;
}

const managerOptions = computed(() => {
  const selfId = props.employee?.id ? Number(props.employee.id) : null;
  const list = Array.isArray(employeeStore.employees)
    ? employeeStore.employees
    : [];

  return list
    .filter((e) => {
      if (!e?.id) return false;
      if (selfId && Number(e.id) === selfId) return false;
      return String(e?.status || "").trim().toLowerCase() === "active";
    })
    .map((e) => ({
      id: Number(e.id),
      text: formatEmployeeOptionLabel(e),
    }));
});

const filteredManagerOptions = computed(() => {
  const q = managerQuery.value.trim().toLowerCase();
  if (!q) return managerOptions.value;
  return managerOptions.value.filter((e) => {
    const t = (e.text || "").toLowerCase();
    const id = String(e.id || "");
    return t.includes(q) || id.includes(q);
  });
});

const selectedManagerLabel = computed(() => {
  const id = Number(form.manager_id || 0);
  if (!id) return "Search & select manager";
  const match = managerOptions.value.find((x) => Number(x.id) === id);
  if (match?.text) return match.text;

  const fromStore = (employeeStore.employees || []).find(
    (e) => Number(e.id) === id
  );
  if (fromStore) return formatEmployeeOptionLabel(fromStore);

  const fromProp = props.employee?.manager;
  if (fromProp && Number(fromProp.id) === id) {
    return formatEmployeeOptionLabel(fromProp);
  }

  return "Selected manager";
});

function chooseManager(opt) {
  form.manager_id = opt.id;
  managerQuery.value = "";
  closeManagerDropdown();
}

function clearManager() {
  form.manager_id = null;
  managerQuery.value = "";
}

function onManagerDropdownOpen() {
  nextTick(() => {
    managerSearchRef.value?.focus();
  });
}

function closeManagerDropdown() {
  document.body.click();
}

onMounted(() => {
  editEmployeeModalEl = document.getElementById("edit_employee");
  editEmployeeModalEl?.addEventListener("shown.bs.modal", onEditEmployeeShown);

  if (!canManageEmployees.value) return;
  if (!departments?.value?.length && departmentStore.fetchDepartments)
    departmentStore.ensureDepartments();
  if (!designations?.value?.length && designationStore.fetchDesignations)
    designationStore.ensureDesignations();
  if (!sectionStore.sections?.length && sectionStore.ensureSections)
    sectionStore.ensureSections();
  if (!companyStore.companies?.length && companyStore.fetchCompanies)
    companyStore.fetchCompanies();
  if (employeeStore.fetchEmployees) {
    employeeStore
      .fetchEmployees({ status: "Active", per_page: 5000 }, { force: false })
      .catch(() => {});
  }
});

onBeforeUnmount(() => {
  editEmployeeModalEl?.removeEventListener("shown.bs.modal", onEditEmployeeShown);
  editEmployeeModalEl = null;
});

defineExpose({ prepareOpen, focusAboutField, openEditEmployeeModal });

const isEdit = computed(() => !!props.employee?.id);
const displayEmpId = computed(() =>
  isEdit.value
    ? props.employee.employee_id
    : form.employee_id || props.nextEmployeeId
);
const companyLabel = computed(() => {
  const c = companyStore.companies.find((c) => c.id === activeCompanyId.value);
  return c ? c.company_name : "";
});

const companies = computed(() =>
  companyStore.companies.map((c) => ({ id: c.id, text: c.company_name }))
);

const dateFormat = "dd-MM-yyyy";

const submitting = ref(false);
const createdId = ref(null);
const IMPORT_PLACEHOLDER_EMAIL_DOMAIN = "@import.donequick.local";

const form = reactive({
  // mirror backend fields
  employee_id: "",
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  status: "Active",
  username: "",
  company_id: null, // tenant enforced server-side
  company_doj: null,
  kra_pin: "",
  national_id: "",
  dob: null,
  gender: "",
  address: "",
  department_id: null,
  section_id: null,
  designation_id: null,
  manager_id: null,
  company: "",
  about: "",
  avatar: null,
  imageUrl: "",
  create_login_user: false,
  send_welcome_email: true,
});

const hasLinkedUser = computed(
  () => !!(props.employee?.user?.id || props.employee?.user_id),
);

const usesPlaceholderEmail = computed(() =>
  String(form.email || "")
    .trim()
    .toLowerCase()
    .endsWith(IMPORT_PLACEHOLDER_EMAIL_DOMAIN),
);

const resendingSetPassword = ref(false);

watch(usesPlaceholderEmail, (isPlaceholder) => {
  if (isPlaceholder) {
    form.create_login_user = false;
  }
});

async function resendSetPasswordEmail() {
  const id = props.employee?.id;
  if (!id) return;
  resendingSetPassword.value = true;
  try {
    const { data } = await employeeService.resendSetPasswordEmail(id);
    toast(data?.message || "Set-password email sent.", "success");
  } catch (e) {
    toast(
      e?.response?.data?.message || "Failed to send set-password email.",
      "error",
    );
  } finally {
    resendingSetPassword.value = false;
  }
}

watch(
  () => props.employee,
  (e) => {
    // hydrate form on open/change
    if (e) {
      form.employee_id = e.employee_id || "";
      form.first_name = e.first_name || "";
      form.last_name = e.last_name || "";
      form.email = e.email || "";
      form.phone = e.phone || "";
      form.status = e.status || "Active";
      form.username = e.username || "";
      form.company_doj = e.company_doj ? new Date(e.company_doj) : null;
      form.dob = e.dob ? new Date(e.dob) : null;
      form.gender = e.gender || "";
      form.kra_pin = e.kra_pin || "";
      form.national_id = e.national_id || "";
      form.department_id = e.department_id || null;
      form.section_id = e.section_id || null;
      form.designation_id = e.designation_id || null;
      form.manager_id = e.manager_id || null;
      form.company_id = e.company_id || null;
      form.company = e.company || "";
      form.address = e.address || "";
      form.about = e.about || "";
      form.avatar = null;
      form.imageUrl = e.avatar_url || "";
      form.create_login_user = false;
      form.send_welcome_email = false;
    } else {
      // reset for add
      form.employee_id = props.nextEmployeeId;
      form.first_name = "";
      form.last_name = "";
      form.email = "";
      form.phone = "";
      form.status = "Active";
      form.username = "";
      form.company_doj = new Date();
      form.dob = null;
      form.gender = "";
      form.kra_pin = "";
      form.national_id = "";
      form.department_id = null;
      form.section_id = null;
      form.designation_id = null;
      form.manager_id = null;
      form.company_id = null;
      form.company = "";
      form.about = "";
      form.avatar = null;
      form.imageUrl = "";
      form.create_login_user = false;
      form.send_welcome_email = true;
    }
  },
  { immediate: true }
);

function onImageChange(ev) {
  const file = ev.target.files?.[0];
  if (!file) return;
  form.avatar = file;
  const reader = new FileReader();
  reader.onload = (e) => (form.imageUrl = e.target?.result);
  reader.readAsDataURL(file);
}
function removeImage() {
  form.avatar = null;
  form.imageUrl = "";
}

const salaryBasisOptions = ["Monthly", "Weekly", "Fortnightly", "Daily", "Hourly", "Yearly"];

const paymentModeOptions = ["Bank Transfer", "Check", "Cash", "Mobile Money"];

const employeeFormRef = ref(null);

// ---------- SUBMIT: Main (create/update) ----------
async function submitMain() {
  submitting.value = true;
  try {
    const payload = new FormData();
    // map fields exactly to backend
    payload.append("first_name", form.first_name);
    payload.append("last_name", form.last_name || "");
    payload.append("email", form.email);
    payload.append("phone", form.phone || "");
    payload.append("status", form.status || "Active");
    payload.append("employee_id", form.employee_id);
    payload.append("username", form.username || "");
    if (form.company_doj)
      payload.append("company_doj", toIsoDate(form.company_doj));
    if (form.dob) payload.append("dob", toIsoDate(form.dob));
    payload.append("company", form.company || "");
    payload.append("kra_pin", form.kra_pin || "");
    payload.append("national_id", form.national_id || "");
    payload.append("gender", form.gender || "");
    payload.append("address", form.address || "");
    payload.append("create_login_user", form.create_login_user ? "1" : "0");
    payload.append("send_welcome_email", form.send_welcome_email ? "1" : "0");

    if (form.department_id)
      payload.append("department_id", String(form.department_id));
    if (form.section_id) {
      payload.append("section_id", String(form.section_id));
    } else if (isEdit.value) {
      payload.append("section_id", "");
    }
    if (form.designation_id)
      payload.append("designation_id", String(form.designation_id));
    if (form.manager_id) {
      payload.append("manager_id", String(form.manager_id));
    } else if (isEdit.value) {
      payload.append("manager_id", "");
    }
    payload.append("about", form.about || "");
    // permissions

    // avatar
    if (form.avatar) payload.append("avatar", form.avatar);

    let res;
    if (isEdit.value) {
      payload.append("_method", "PUT");
      res = await employeeStore.updateEmployee?.(props.employee.id, payload);
    } else {
      res = await employeeStore.createEmployee?.(payload);
      createdId.value = res?.id || res?.employee?.id || null;
    }

    await closeModal("edit_employee");
    emit("saved", res || {});
  } catch (err) {
    // surface minimal error; you can expand with toasts
    console.error("Save failed", err);
  } finally {
    submitting.value = false;
  }
}

function toIsoDate(d) {
  const dt = new Date(d);
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const da = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${da}`;
}

// put near your other helpers
function toDateOrNull(v) {
  if (!v) return null;
  if (v instanceof Date) return v;

  // try ISO (YYYY-MM-DD) or any Date-parsable string
  const d1 = new Date(v);
  if (!Number.isNaN(d1.getTime())) return d1;

  // fallback for dd-MM-yyyy or dd/MM/yyyy
  const parts = String(v).split(/[-/]/);
  if (parts.length === 3) {
    const [dd, mm, yyyy] = parts.map((p) => parseInt(p, 10));
    const d2 = new Date(yyyy, (mm || 1) - 1, dd || 1);
    if (!Number.isNaN(d2.getTime())) return d2;
  }
  return null;
}

function toIsoDateSafe(v) {
  const d = v instanceof Date ? v : toDateOrNull(v);
  if (!d) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const da = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${da}`;
}

// ---------- SUBMIT: Minor modals (partial updates) ----------
const MartSel = ["Select", "Single", "Married", "Divorced", "Widowed"];

const minorForm = reactive({
  salary_basis: "",
  payment_mode: "",
  pay_frequency: "monthly",

  // personal
  passport_no: "",
  passport_expiry: null,
  nationality: "",
  religion: "",
  marital_status: "",
  employment_spouse: "",
  no_of_children: "",
  nhif_number: "",
  nssf_number: "",

  // emergency
  primary_emergency_contact_name: "",
  primary_emergency_contact_relationship: "",
  primary_emergency_contact_phone: "",
  primary_emergency_contact_phone_two: "",
  secondary_emergency_contact_name: "",
  secondary_emergency_contact_relationship: "",
  secondary_emergency_contact_phone: "",
  secondary_emergency_contact_phone_two: "",

  // bank
  bank_name: "",
  bank_code: "", // 🔹 NEW
  account_number: "",
  account_holder_name: "",
  branch_location: "",
  branch_code: "", // 🔹 NEW

  // family
  family_contact_name: "",
  family_contact_relationship: "",
  family_contact_phone: "",

  // education (sample)
  education_institution: "",
  education_course: "",
  education_start_date: null,
  education_end_date: null,

  // experience
  previous_employer: "",
  job_designation: "",
  employment_start_date: null,
  employment_end_date: null,
  currently_working: false,
  educations: [],
  experiences: [],
});

watch(
  () => props.employee,
  (e) => {
    if (!e) return;
    // preload a few
    minorForm.salary_basis = e.salary_basis || "";
    minorForm.payment_mode = e.payment_mode || "";
    minorForm.pay_frequency = e.pay_frequency || "monthly";
    minorForm.passport_no = e.passport_no || "";
    minorForm.nationality = e.nationality || "";
    minorForm.religion = e.religion || "";
    minorForm.marital_status = e.marital_status || "";
    minorForm.no_of_children = e.no_of_children || "";
    minorForm.employment_spouse = e.employment_spouse || "";
    minorForm.nhif_number = e.nhif_number || "";
    minorForm.nssf_number = e.nssf_number || "";

    minorForm.primary_emergency_contact_name =
      e.primary_emergency_contact_name || "";
    minorForm.primary_emergency_contact_relationship =
      e.primary_emergency_contact_relationship || "";
    minorForm.primary_emergency_contact_phone =
      e.primary_emergency_contact_phone || "";
    minorForm.primary_emergency_contact_phone_two =
      e.primary_emergency_contact_phone_two || "";

    minorForm.secondary_emergency_contact_name =
      e.secondary_emergency_contact_name || "";
    minorForm.secondary_emergency_contact_relationship =
      e.secondary_emergency_contact_relationship || "";
    minorForm.secondary_emergency_contact_phone =
      e.secondary_emergency_contact_phone || "";
    minorForm.secondary_emergency_contact_phone_two =
      e.secondary_emergency_contact_phone_two || "";

    minorForm.bank_name = e.bank_name || "";
    minorForm.bank_code = e.bank_code || ""; // 🔹 NEW
    minorForm.account_number = e.account_number || "";
    minorForm.account_holder_name = e.account_holder_name || "";
    minorForm.branch_location = e.branch_location || "";
    minorForm.branch_code = e.branch_code || ""; // 🔹 NEW

    minorForm.family_contact_name = e.family_contact_name || "";
    minorForm.family_contact_relationship = e.family_contact_relationship || "";
    minorForm.family_contact_phone = e.family_contact_phone || "";

    minorForm.previous_employer = e.previous_employer || "";
    minorForm.job_designation = e.job_designation || "";
    minorForm.employment_start_date = e.employment_start_date
      ? new Date(e.employment_start_date)
      : null;
    minorForm.employment_end_date = e.employment_end_date
      ? new Date(e.employment_end_date)
      : null;
    minorForm.currently_working = !!e.currently_working;

    // --- EDUCATIONS ---
    minorForm.educations = Array.isArray(e.educations)
      ? e.educations
          .map((edu) => ({
            institution_name: edu.institution_name || edu.institution || "",
            course: edu.course || "",
            start_date: toDateOrNull(edu.start_date || edu.education_start_date),
            end_date: toDateOrNull(edu.end_date || edu.education_end_date),
            graduated: !!edu.graduated,
          }))
          .filter(
            (edu) =>
              edu.institution_name ||
              edu.course ||
              edu.start_date ||
              edu.end_date
          )
      : e.institution_name || e.course
      ? [
          {
            institution_name: e.institution_name || "",
            course: e.course || "",
            start_date: toDateOrNull(e.education_start_date),
            end_date: toDateOrNull(e.education_end_date),
            graduated: !!e.graduated,
          },
        ]
      : [];

    // --- EXPERIENCES ---
    minorForm.experiences = Array.isArray(e.experiences)
      ? e.experiences
          .map((exp) => ({
            company: exp.company || e.previous_employer || "",
            designation: exp.designation || e.job_designation || "",
            start_date: toDateOrNull(exp.start_date || e.employment_start_date),
            end_date: toDateOrNull(exp.end_date || e.employment_end_date),
            currently_working: !!exp.currently_working,
            responsibilities: exp.responsibilities || "",
            supervisor_name: exp.supervisor_name || "",
            supervisor_phone: exp.supervisor_phone || "",
          }))
          .filter(
            (exp) =>
              exp.company ||
              exp.designation ||
              exp.start_date ||
              exp.end_date ||
              exp.responsibilities ||
              exp.supervisor_name ||
              exp.supervisor_phone
          )
      : e.previous_employer || e.job_designation
      ? [
          {
            company: e.previous_employer || "",
            designation: e.job_designation || "",
            start_date: toDateOrNull(e.employment_start_date),
            end_date: toDateOrNull(e.employment_end_date),
            currently_working: !!e.currently_working,
            responsibilities: e.responsibilities || "",
            supervisor_name: e.supervisor_name || "",
            supervisor_phone: e.supervisor_phone || "",
          },
        ]
      : [];
  },
  { immediate: true }
);

watch(
  () => form.department_id,
  () => {
    if (!filteredSections.value.some((s) => s.id === form.section_id)) {
      form.section_id = null;
    }
    if (!filteredDesignations.value.some((d) => d.id === form.designation_id)) {
      form.designation_id = null;
    }
  }
);

watch(
  () => form.section_id,
  () => {
    if (!filteredDesignations.value.some((d) => d.id === form.designation_id)) {
      form.designation_id = null;
    }
  }
);

function getOpenMinorModalId() {
  return [
    "edit_personal",
    "edit_emergency",
    "edit_bank",
    "edit_familyinformation",
    "edit_education",
    "edit_experience",
  ].find((id) => {
    const el = document.getElementById(id);
    return el && (el.classList.contains("show") || el.style.display === "block");
  });
}

const MINOR_SECTION_FIELDS = {
  edit_personal: [
    "salary_basis",
    "payment_mode",
    "pay_frequency",
    "passport_no",
    "passport_expiry",
    "nssf_number",
    "nhif_number",
    "nationality",
    "religion",
    "marital_status",
  ],
  edit_emergency: [
    "primary_emergency_contact_name",
    "primary_emergency_contact_relationship",
    "primary_emergency_contact_phone",
    "primary_emergency_contact_phone_two",
    "secondary_emergency_contact_name",
    "secondary_emergency_contact_relationship",
    "secondary_emergency_contact_phone",
    "secondary_emergency_contact_phone_two",
  ],
  edit_bank: [
    "bank_name",
    "bank_code",
    "account_number",
    "account_holder_name",
    "branch_location",
    "branch_code",
  ],
  edit_familyinformation: [
    "family_contact_name",
    "family_contact_relationship",
    "family_contact_phone",
    "no_of_children",
  ],
  edit_education: ["educations"],
  edit_experience: ["experiences"],
};

function isBlankEducation(edu) {
  return !(
    String(edu?.institution_name || "").trim() ||
    String(edu?.course || "").trim() ||
    edu?.start_date ||
    edu?.end_date
  );
}

function isBlankExperience(exp) {
  return !(
    String(exp?.company || "").trim() ||
    String(exp?.designation || "").trim() ||
    exp?.start_date ||
    exp?.end_date ||
    String(exp?.responsibilities || "").trim() ||
    String(exp?.supervisor_name || "").trim() ||
    String(exp?.supervisor_phone || "").trim()
  );
}

function mapEducationsPayload(list) {
  return (Array.isArray(list) ? list : [])
    .filter((edu) => !isBlankEducation(edu))
    .map((edu) => ({
      institution_name: String(edu.institution_name || "").trim(),
      course: edu.course || "",
      start_date: toIsoDateSafe(edu.start_date),
      end_date: toIsoDateSafe(edu.end_date),
      graduated: !!edu.graduated,
    }));
}

function mapExperiencesPayload(list) {
  return (Array.isArray(list) ? list : [])
    .filter((exp) => !isBlankExperience(exp))
    .map((exp) => ({
      company: String(exp.company || "").trim(),
      designation: exp.designation || "",
      start_date: toIsoDateSafe(exp.start_date),
      end_date: toIsoDateSafe(exp.end_date),
      currently_working: !!exp.currently_working,
      responsibilities: exp.responsibilities || "",
      supervisor_name: exp.supervisor_name || "",
      supervisor_phone: exp.supervisor_phone || "",
    }));
}

async function submitMinor() {
  if (!props.employee?.id) return;
  submitting.value = true;
  try {
    const openMinor = getOpenMinorModalId();
    const allowedKeys = openMinor ? MINOR_SECTION_FIELDS[openMinor] : null;
    const payload = {};

    if (allowedKeys) {
      for (const k of allowedKeys) {
        if (k === "educations") {
          payload.educations = mapEducationsPayload(minorForm.educations);
          continue;
        }
        if (k === "experiences") {
          payload.experiences = mapExperiencesPayload(minorForm.experiences);
          continue;
        }
        const v = minorForm[k];
        if (v === null || typeof v === "undefined") continue;
        const apiKey = k === "passport_expiry" ? "passport_expiry_date" : k;
        payload[apiKey] = v instanceof Date ? toIsoDate(v) : v;
      }
    } else {
      // Fallback: send scalars only (never both arrays unless scoped)
      Object.entries(minorForm).forEach(([k, v]) => {
        if (k === "educations" || k === "experiences") return;
        if (v === null || typeof v === "undefined") return;
        if (v instanceof Date) payload[k] = toIsoDate(v);
        else payload[k] = v;
      });
    }

    if (openMinor === "edit_education") {
      const incomplete = (minorForm.educations || []).find(
        (edu) =>
          !isBlankEducation(edu) && !String(edu.institution_name || "").trim()
      );
      if (incomplete) {
        toast("Institution name is required for each education entry.", "error");
        return;
      }
    }

    if (openMinor === "edit_experience") {
      const incomplete = (minorForm.experiences || []).find(
        (exp) => !isBlankExperience(exp) && !String(exp.company || "").trim()
      );
      if (incomplete) {
        toast("Company name is required for each experience entry.", "error");
        return;
      }
    }

    const res = await employeeStore.updateEmployee?.(
      props.employee.id,
      payload
    );

    await closeOpenEditableModals(openMinor || null);
    emit("saved", res || {});
  } catch (e) {
    console.error("Partial update failed", e);
  } finally {
    submitting.value = false;
  }
}

// Delete employee (optional – if you choose to enable from details)
async function confirmDelete() {
  try {
    if (!props.employee?.id || !employeeStore.deleteEmployee) return;
    await employeeStore.deleteEmployee(props.employee.id);
    await closeModal("delete_modal");
    emit("saved", { deleted: true });
  } catch (e) {
    console.error("Delete failed", e);
  }
}

// ---------- BANK / BRANCH DROPDOWNS ----------

// search queries
const bankQuery = ref("");
const branchQuery = ref("");

// unique bank list: { bank_name, bank_code }
const uniqueBanks = computed(() => {
  const map = new Map();
  bankList.forEach((b) => {
    if (!map.has(b.bank_name)) {
      map.set(b.bank_name, b.bank_code);
    }
  });
  return Array.from(map, ([bank_name, bank_code]) => ({
    bank_name,
    bank_code,
  }));
});

// bank filter
const filteredBanks = computed(() => {
  const q = bankQuery.value.trim().toLowerCase();
  if (!q) return uniqueBanks.value;
  return uniqueBanks.value.filter((b) => b.bank_name.toLowerCase().includes(q));
});

// branches available for selected bank
const availableBranches = computed(() => {
  if (!minorForm.bank_name) return [];
  return bankList.filter((b) => b.bank_name === minorForm.bank_name);
});

// branch filter
const filteredBranches = computed(() => {
  const q = branchQuery.value.trim().toLowerCase();
  let list = availableBranches.value;
  if (!q) return list;
  return list.filter(
    (b) =>
      b.branch_name.toLowerCase().includes(q) ||
      String(b.branch_code).toLowerCase().includes(q)
  );
});

// choose bank: set bank name + code and reset branch fields
function chooseBank(bank) {
  minorForm.bank_name = bank.bank_name;
  minorForm.bank_code = bank.bank_code || "";
  // reset branch stuff when bank changes
  minorForm.branch_location = "";
  minorForm.branch_code = "";
  branchQuery.value = "";
}

// choose branch: set branch name + code
function chooseBranch(branch) {
  minorForm.branch_location = branch.branch_name;
  minorForm.branch_code = branch.branch_code || "";
}

// roles (normalize once)
const authRoles = computed(() =>
  (authUser.value?.roles || [])
    .map((r) => (typeof r === "string" ? r : r?.name))
    .filter(Boolean)
);

// keep your isSuperAdmin as-is, or simplify using authRoles:
const isSuperAdmin = computed(() => authRoles.value.includes("SuperAdmin"));

// ✅ FIX (was: auth.user?.roles)
const isAdmin = computed(() => authRoles.value.includes("Admin"));

// optional: if you have HR role in your system
const isHR = computed(
  () => authRoles.value.includes("HR") || authRoles.value.includes("Hr")
);

// "admin-like" users who can manage employee records
const canManageEmployees = computed(
  () => isSuperAdmin.value || isAdmin.value || isHR.value
);

// employee self-service mode (non-admin users)
const isEmployeeSelfService = computed(() => !canManageEmployees.value);

/**
 * Field-level permissions for EMPLOYEE self-service (typical HRMS)
 * - Admin/HR: can edit everything
 * - Employee: can update only safe personal/contact/profile fields
 */
const fieldAccess = computed(() => {
  const admin = canManageEmployees.value;

  return {
    // --- Main form (basic)
    avatar: true, // employee can upload own profile photo
    first_name: admin, // usually locked for employees (HR edits)
    last_name: admin, // (or set true if you want employees to edit names)
    employee_id: admin, // system-controlled
    company_doj: admin, // HR-controlled
    username: admin, // typically locked
    email: admin, // typically locked (or allow if your policy allows)
    phone: true, // employee can update
    kra_pin: admin, // sensitive compliance (HR edits)
    national_id: admin, // sensitive compliance (HR edits)
    company_id: admin, // tenant/company selection is admin-only
    department_id: admin, // org structure (HR edits)
    section_id: admin, // org structure (HR edits)
    designation_id: admin, // org structure (HR edits)
    manager_id: admin, // reporting line (HR edits)
    dob: true, // employee can update
    gender: true, // employee can update
    address: true, // employee can update
    about: true, // employee can update
    status: admin, // HR-only (not shown in template but you submit it)

    // --- Minor modals
    salary_basis: admin, // payroll/admin only
    payment_mode: admin, // payroll/admin only
    pay_frequency: admin, // payroll/admin only

    // personal info
    passport_no: true,
    passport_expiry: true,
    nationality: true,
    religion: true,
    marital_status: true,
    employment_spouse: true,
    no_of_children: true,

    // statutory (you can choose)
    nhif_number: admin, // usually HR/payroll (set true if you want employee to edit)
    nssf_number: admin, // usually HR/payroll

    // emergency
    emergency: true,

    // bank
    bank: true,

    // family/education/experience
    family: true,
    education: true,
    experience: true,
  };
});

const nonMonthlyPayFrequencySelected = computed(() => {
  const freq = String(minorForm.pay_frequency || "monthly").toLowerCase();
  return freq !== "monthly" && freq !== "";
});
</script>

<style scoped>
.display-none {
  display: none !important;
}

.dq-emp-dd .dq-dd-menu {
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.12);
}

.dq-search-list {
  max-height: 260px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 12px;
}

.dq-dd-item {
  border-radius: 10px;
  padding: 10px 10px;
}

.dq-dd-item:active {
  background: rgba(13, 110, 253, 0.08);
}

.dq-dd-btn {
  border-radius: 12px;
}
</style>
